import React from 'react';
import { COLOR_PALETTE, getDarkerColor } from '../../../components/widgets/shared/barGraphUtils';

export interface BarSegmentLegendItem {
  label: string;
  /** Darker shade of the bar's colour (the stacked second segment). */
  darken?: boolean;
}

/**
 * Key for a stacked Home bar chart (W-M16a): each bar is drawn in its service area's colour,
 * with the second segment a darker shade, so the key shows the shade, not a fixed colour.
 */
const BarSegmentLegend: React.FC<{ items: BarSegmentLegendItem[]; 'aria-label'?: string }> = ({
  items,
  'aria-label': ariaLabel = 'Chart key',
}) => {
  const base = COLOR_PALETTE[0];
  return (
    <ul
      className="tw-m-0 tw-flex tw-list-none tw-flex-wrap tw-items-center tw-gap-x-4 tw-gap-y-1 tw-p-0 tw-text-xs tw-text-content-secondary"
      aria-label={ariaLabel}
    >
      {items.map((item) => (
        <li key={item.label} className="tw-inline-flex tw-items-center tw-gap-1.5">
          <span
            className="tw-inline-block tw-h-2.5 tw-w-4 tw-rounded-sm"
            style={{ backgroundColor: item.darken ? getDarkerColor(base, 0.3) : base }}
            aria-hidden="true"
          />
          {item.label}
        </li>
      ))}
    </ul>
  );
};

export default BarSegmentLegend;
